import clsx from "clsx";
import { useRef, useState } from "react";

import { useTimeRemaining } from "../../../utils/hooks/use-time-remaining";

import { TimerControls } from "./TimerControls";

import { IconText } from "mds/components/IconText";
import { Menu, MenuInstance } from "mds/components/Menu";
import { PillButton } from "mds/components/PillButton";
import { ChevronUpIcon, ClockIcon } from "mds/icons";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectClassTimerEndsAt } from "store/selectors";

export const TimerBanner = () => {
  const { canAuthorSection } = useCapabilities();
  const endTime = useAppSelector(selectClassTimerEndsAt);
  const endDate = endTime ? new Date(endTime) : null;
  const { timeRemainingStrMd } = useTimeRemaining(endDate);
  const menuRef = useRef<MenuInstance>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  if (!endTime || !timeRemainingStrMd) return null;

  const MenuButton = (
    <PillButton
      className={clsx("gap-2 font-medium", !canAuthorSection && "cursor-default")}
      eventName="Classroom Timer menu opened"
      kind="banner-blue"
      size="m"
    >
      <IconText
        iconEnd={canAuthorSection ? <ChevronUpIcon /> : undefined}
        iconStart={<ClockIcon />}
        text={<span className="min-w-[42px] text-left">{timeRemainingStrMd}</span>}
      />
    </PillButton>
  );

  if (!canAuthorSection) {
    return MenuButton;
  }

  return (
    <Menu
      className="dark-menu min-w-[180px]"
      direction="top"
      instanceRef={menuRef}
      menuButton={MenuButton}
      onMenuChange={(e) => setMenuOpen(e.open)}
    >
      {menuOpen ? <TimerControls onClose={() => menuRef.current?.closeMenu()} /> : null}
    </Menu>
  );
};
